<template>
  <div class="aivideo-doc" :class="[{ active: currentCid && watchOpen }]">
    <div
      v-for="cid in cids"
      :key="cid"
      :id="cid"
      v-show="currentCid == cid"
      class="doc-box"
      :style="cid.split('-')[0] == 'document' ? docBoxStyle : boardBoxStyle"
    ></div>

    <div class="doc-pager">{{ pageNum }}/{{ pageTotal }}</div>
  </div>
</template>
<script>
  export default {
    name: 'AiDoc',
    data() {
      return {
        docSDK: null,

        cids: [],
        currentCid: '',
        docBoxStyle: {
          width: 336,
          height: 189
        }, // 文档宽高
        boardBoxStyle: {
          width: 336,
          height: 189
        },
        watchOpen: false, // 是否观众可见

        pageNum: 1,
        pageTotal: 1
      };
    },
    created() {
      this.initEvent();
    },
    methods: {
      initEvent() {
        this.$emitter.on('initDocSDK', options => {
          this.initDocSDK(options);
        });
      },
      initDocSDK(options) {
        const params = {
          accountId: options.accountId,
          roomId: options.doc.roomId,
          channelId: options.doc.channelId, // 频道id 必须
          appId: options.paasAppId, // appId 必须
          role: 2, // 角色观众 必须
          isVod: true, // 是否是回放 必须 options.doc.isVod
          client: window.VHDocSDK.Client.PC_WEB, // 客户端类型
          token: options.paasAccessToken
        };
        this.$log.info('doc 初始化文档sdk params:', params);
        let success = () => {
          this.$log.info('doc 实例化文档成功');
          // this.$EventBus.$emit('docSDK_ready', this.docSDK);
        };
        let failed = error => {
          console.error('doc 实例化文档失败', error.msg);
        };
        this.docSDK = window.VHDocSDK.createInstance(params, success, failed);

        this.docSDK.on(window.VHDocSDK.Event.VOD_CUEPOINT_LOAD_COMPLETE, async ({ chapters }) => {
          this.$store.commit('video/setHasVodDoc', true);

          const data = this.docSDK.getVodAllCids();
          this.$log.info('doc VOD_CUEPOINT_LOAD_COMPLETE', data);
          this.cids = data.map(item => item.cid);
          await this.$nextTick();
          data.forEach(({ cid, type }) => {
            this.initDocContainer({ type: type.toLowerCase(), id: cid });
          });
        });
        // 监听回放事件
        this.docSDK.on(window.VHDocSDK.Event.VOD_TIME_UPDATE, data => {
          this.watchOpen = data.watchOpen;
          if (data.activeId) {
            this.selectContainer(data.activeId);
          } else {
            this.currentCid = '';
          }
          // {container:[容器id], activeid: 容器id, watchOpen: true | false}
        });

        // 当前文档加载完成
        this.docSDK.on(window.VHDocSDK.Event.DOCUMENT_LOAD_COMPLETE, data => {
          this.pageTotal = data.info.slidesTotal;
          this.pageNum = Number(data.info.slideIndex) + 1;
        });

        // 文档翻页事件
        this.docSDK.on(VHDocSDK.Event.PAGE_CHANGE, data => {
          this.pageTotal = data.info.slidesTotal;
          this.pageNum = Number(data.info.slideIndex) + 1;
        });
      },
      /**
       * 初始化文档容器
       */
      initDocContainer(data) {
        if (data.type === 'document') {
          let opts = {
            id: data.id,
            docId: data.docId || '',
            elId: data.id, // div 容器 必须
            width: parseFloat(this.docBoxStyle.width), // div 宽度，像素单位，数值型不带px 必须
            height: parseFloat(this.docBoxStyle.height), // div 高度，像素单位，数值型不带px 必须
            noDispatch: !data.select // 通过监听创建容器消息创建的需要派发加载完成消息
          };
          this.docSDK.createDocument(opts);
        } else {
          this.boardID = data.id;
          let opts = {
            id: data.cid,
            elId: data.id, // div 容器 必须
            width: parseFloat(this.boardBoxStyle.width), // div 宽度，像素单位，数值型不带px 必须
            height: parseFloat(this.boardBoxStyle.height), // div 高度，像素单位，数值型不带px 必须
            noDispatch: !data.select,
            backgroundColor: '#FFFFFF'
          };
          this.docSDK.createBoard(opts);
        }
      },
      selectContainer(id) {
        this.docSDK.selectContainer({ id });
        this.currentCid = id;
      }
    }
  };
</script>
<style lang="less" scoped>
  .aivideo-doc {
    position: relative;
    box-sizing: border-box;
    border: 0;
    height: 1px;
    background-color: #fff;
    overflow: hidden;
    z-index: 20;

    &.active {
      height: 189px;
    }

    .doc-pager {
      position: absolute;
      bottom: 12px;
      left: 50%;
      transform: translateX(-50%);
      width: 57px;
      z-index: 10;
      font-size: 14px;
      border-radius: 10.914px;
      background: rgba(0, 0, 0, 0.4);
      color: #fff;
      line-height: 22px;
      text-align: center;
    }
  }
</style>
